import { Component, EventEmitter, Input, Output } from '@angular/core';

interface Item {
  id: number;
  label: string;
}

@Component({
  selector: 'app-list-select',
  templateUrl: './list-select.component.html',
  standalone: false
})
export class ListSelectComponent {

  @Input() availableItemsList: Item[] = [];
  @Input() selectedItemsList: Item[] = [];
  @Input() availableListName: string = '';
  @Input() selectedListName: string = '';
  @Input() disabled = false;

  @Output() selectedItemsListChange = new EventEmitter<Item[]>();

  selectItems(item: Item | null | undefined): void {
    if (this.disabled || !item) {
      return;
    }
    if (this.selectedItemsList.some(selected => selected.id === item.id)) {
      return;
    }
    this.selectedItemsListChange.emit([...this.selectedItemsList, item]);
  }

  removeItem(item: Item | null | undefined): void {
    if (this.disabled || !item) {
      return;
    }
    this.selectedItemsListChange.emit(
      this.selectedItemsList.filter(selected => selected.id !== item.id)
    );
  }

}
